import * as React from 'react';
import ApplyStepTitle from './applyStepTitle';
import ApplyStepProcess from './applyStepProcess';
import classNames from 'classnames/bind';
import styles from './applyStep.module.scss';

const cx = classNames.bind(styles);

const ApplyStep = () => {
  return (
    <div className={cx('processResultArea')}>
      {/* [D] 텍스트 영역 */}
      <ApplyStepTitle />

      {/* [D] 리스트 영역 */}
      <ApplyStepProcess />
    </div>
  );
};

export default ApplyStep;
